<template> 
<div> 
 <div class="loyalty-main-container" >
    <div class="loyalty-inner-container" >
      <div class="loyalty-content-container">
        <div class="loyalty-container-col loyalty-container-col__column1">
          <div class="inner-container">
            <div class="loyalty-container-col__column1-image">
              <div class="inner-container-image">
                <img :src="leftSideImage" class="left-image" >
              </div>
            </div>
            <div class="about-three-column-single-text-container loyalty-container-col__column1-body">
               <div class="swell-shiko-beauty refer">
                    <div class="refer-section">
                      <div class="yotpo-widget-instance" data-yotpo-instance-id="81477" share-copy-link-text=" "
             share-link-copied-text=" "
             share-facebook-button-text=" "
             share-facebook-messenger-button-text=" "
             share-twitter-button-text=" "
             share-whatsapp-button-text=" "
             ></div>
                  </div>
                  </div>
              
             
            </div>
          </div>
        </div>

        <div class="loyalty-container-col loyalty-container-col__column2" :style="{'background-image': `url(${schema.settings.rightBackgroundImage})`}">
           
          <div class="about-three-column-single-text-container">
            <div class="h4 headline-1" v-html="schema.settings.rightHeading1"></div>
              <div class="body-md-mobile body-md-tablet-up bodyText" v-html="schema.settings.rightHeading2"></div>
                <div>
                  <v-link secondary :href="schema.settings.ctaUrl" class="button-shopnow">{{schema.settings.ctaText}}</v-link>
                </div>
              </div>
        </div>
      </div>
    </div>
  </div> 
  
</div>
</template>

<script>
import VButton from '@/scripts/components/buttons/VButton.vue'
import VLink from '@/scripts/components/buttons/VLink.vue';

export default {
  name: 'SpecialPromotionLoyalty',
  components: {
    VButton,
    VLink
  },
  props: {
    schema: Object
  },
  computed: {
    leftSideImage() {
      if (this.$mq !== 'mobile') {
        return this.schema.settings.leftImage;
      } else {
        return this.schema.settings.mobileLeftImage;
      } 
    }
  } 
}
</script>

<style scoped lang="scss">
  .loyalty-main-container {
    padding-top: 48px;
    padding-bottom: 48px;
  }

  .inner-container {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    padding: 1px 61px;
    
    @include mobile-only {
      flex-direction: column; 
      padding: 55px 40px;
    }
  }

  .loyalty-inner-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
    @include desktop-up {
      max-width: $container-max-width;
      margin-left: auto;
      margin-right: auto;
      padding-right: 16px;
      padding-left: 16px;
    }
  }

  .loyalty-container-col {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-top: 0;

    &__column1 {
      background:#F6F3F0;
      flex:2;

      .headline-1 {
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 4.5px;
        text-transform: uppercase;
        margin-bottom: 16px;
        
        @include mobile-only {
          margin-top: 35px;
          line-height: 14px;
        }
      }

      .headline-2 {
        color: $color-black-900;
        line-height: 42px;
        @include mobile-only {
          line-height: 34px;
          font-size: 28px;
          letter-spacing: 0;
        }
      }
      .left-image {
        @include desktop-up {
          height: 440px;
        }
      }

      
    }
    &__form {
      margin-top: 20px;
    }
    &__column1-image {
      @include desktop-up {
        flex:1;
        flex-basis: 103px;
      }
      

    }
    &__column1-body {
      text-align: left;
      color: $color-black-700;

      @include desktop-up {
        flex:2;
        padding-right: 10px;
      }

      
    }
     &__column2 {
      flex:1;
      justify-content: flex-start;
      background-size: contain;
      background-repeat: no-repeat;
      padding-top: 120px;
      

      @include mobile-only {
        min-height: 549px;
        background-size: cover;
      }


      .left-logo {
        padding-top:50px;
        
        width:120px;
        @include mobile-only {
          margin-top: 17px;
        }
      }
      .headline-1 {
        color: $color-black-900;
        letter-spacing: 0;
        line-height: 42px;
        margin-bottom: 11px;
        margin-top: 14px;
        font-size: 32px;
      }
      .bodyText {
        color: $color-black-700;
        font-size: 15px;
        letter-spacing: -0.1px;
        line-height: 23px;
        text-align: center;
        padding-left: 66px;
        padding-right: 66px;
        margin-bottom: 25px;

      }
    }

    
  }

  .body-text {
    font-size: 12px;
    line-height: 23px;
    max-width: 416px;

    @include desktop-up {
      font-size: 16px;
      max-width: 290px;
    }
    @include mobile-only {
      margin-top: 20px;
    }

    @media screen and (min-width: 1200px) {
      max-width: 416px;
    }
  }

  .loyalty-container-col:last-child {
    margin-bottom: 0;
  }

  /deep/ .loyalty_form input{
    background: #f6f3f0;
    border-bottom: 1px solid $color-brand-primary;
    color: $color-brand-primary ;
  }

  

  .left-aligned {

    @include desktop-up {
      align-items: flex-start;
      justify-content: flex-start;

      .about-three-column-single-text-container {
        max-width: 290px;
        padding-left: 32px;
        word-break: break-all;
      }
    }

    .loyalty-content-container {
      @include desktop-up {
        align-items: flex-start;
      }
    }

    .loyalty-header-container {

      @include desktop-up {
        text-align: left;
      }
    }

    .loyalty-container-col {

      @include desktop-up {
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        text-align: left;
        margin-top: 0;
        margin-right: 16px;
        margin-bottom: 0;
      }
    }



    .body-text {
      @include desktop-up {
        margin-bottom: 16px;
        max-width: 290px;
      }
    }

    .about-three-column-cta {

      @include desktop-up {
        margin-top: 0;
      }
    }
  }

  .stacked.left {

    @include desktop-up {
      align-items: flex-start;
      width: 100%;
       .loyalty-header-container {
        text-align: left;
       }
      .loyalty-container-col {
        margin-right: 32px;
        margin-left: 0;
        max-width: 416px;
        width: 33.3%;
        align-items: flex-start;
        justify-content: flex-start;
        text-align: left;
      }

      .loyalty-content-container {
        align-items: flex-start;
      }

       
    }
  }

  .stacked.center {

    @include desktop-up {
      .loyalty-container-col {
        padding-right: 16px;
        padding-left: 16px;
      }
    }
  }

  .loyalty-content-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: stretch;
    column-gap: 16px;
    min-height: 549px;

    @include desktop-up {
      flex-direction: row;
      justify-content: space-between;
    }
  }



  .loyalty-header-container {
    margin-bottom: 32px;
    text-align: center;

    @include desktop-up {
      margin-bottom: 40px;
    }
  }
  

  .about-three-column-cta {
    margin-top: 16px;
    text-align: center;
    padding: 0;
  }
  .button-shopnow { 
    color: $color-black-900;
    font-size: 18px;
    letter-spacing: 0.2px;
    line-height: 20px;
  }
</style>
